import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FortisButton from '../../../components/Basic/FortisButton';
import DoublePassword, { DoublePasswordValidation } from '../../../components/Sections/DoublePassword';
import util from '../../../lib/util';
import { browserHistory } from 'react-router';


class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    props.initAPI();
    this.state = { isSubmitClicked: false };
  }


  componentWillReceiveProps(p) {
    if (p.forgotPasswordSuccess) {
      p.resetPasswordSuccess();
      browserHistory.push('/login');
    }
  }
  onSubmitClick = () => {
    const p = this.props;
    let validators = [
      ...DoublePasswordValidation('password')
    ];
    if (util.validate(validators, p.form, p.formError)) {
      let model = {
        UserId: p.userId,
        Password: p.password,
        ConfirmPassword: p.password,
        Code: p.code
      };
      p.resetPassword(model);
      this.setState({ isSubmitClicked: true });
    }
  }
  render() {
    const p = this.props;
    const technicalError = window.osa && window.osa.commonLookup && window.osa.commonLookup.technicalError;
    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="panel panel-default">
          <div className="panel-body">
            <div className="row">
              <div className="col-md-12">
                <h3 className="panel-title text-primary" style={{ "font-size": "24px" }}>Reset password</h3> <br />
                <hr className="soften" />
                <div>
                  <label>Create a new password</label><br />
                  <span>Your password must be at least eight characters long and include one number, one lowercase letter and one capital letter.</span>
                </div>
                <div>
                  <DoublePassword name="password" title1="Enter new password" title2="Re-enter new password" required />
                </div>
                <br />
                <div className="form-group">
                  <div className="row text-center">
                    <div className="col-lg-12" style={{ "display": "inline-block" }}>
                      <FortisButton text="Reset password" onClick={this.onSubmitClick} />
                    </div>
                  </div>
                </div>
                {
                  this.state.isSubmitClicked ?
                    <div>
                      {
                        !p.resetPasswordSuccess ?
                          <div className="row animated-element animate-show" >
                            <div className="col-sm-12">
                              <div className="row">
                                <div className="col-sm-12">
                                  <span dangerouslySetInnerHTML={{ __html: technicalError }} />
                                </div>
                              </div>
                            </div>
                          </div>
                          :
                          <div className="col-sm-12">
                            <div className="row">
                              <div className="col-sm-12">
                                Your password has been reset. You may now <a onClick={() => browserHistory.push('/login')}>log in.</a>
                              </div>
                            </div>
                          </div>
                      }
                    </div>
                    :
                    null
                }

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  form: PropTypes.object,
  password: PropTypes.string,
  userId: PropTypes.string,
  code: PropTypes.string,
  resetPasswordSuccess: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    form: state.form,
    password: state.form.password,
    userId: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["userId"],
    code: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["code"],
    resetPasswordSuccess: state.gas.resetPasswordSuccess
  };
}
function mapDispatchToProps(dispatch) {
  return {
    initAPI: () => {
      dispatch({ type: 'INITIALIZE_RESETPASSWORD' });
      dispatch({ type: 'INITIALIZE_API' });
    },
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    resetPassword: (model) => dispatch({ type: 'RESET_PASSWORD', model }),
    resetPasswordSuccess: () => dispatch({ type: 'RESET_PASSWORD_SUCCESS', resetPasswordSuccess: false })

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);

